import React from "react";
import type { FunnelStepView } from "../../../lib/metrics-display";
import { FunnelBar } from "./funnel-bar";

export function FunnelStepRow({
  step,
  medicareCapped,
}: {
  step: FunnelStepView;
  medicareCapped: number;
}) {
  return (
    <div className="flex items-center gap-[14px]">
      <div className="w-[150px] shrink-0">
        <p className="text-title-sm font-medium leading-[18px] text-foreground">
          {step.label}
        </p>
        {step.sublabel && (
          <p className="text-body leading-[15px] text-muted-foreground">
            {step.sublabel}
          </p>
        )}
      </div>
      <FunnelBar step={step} medicareCapped={medicareCapped} />
      <p className="w-[120px] shrink-0 text-body text-muted-strong">
        <b className="text-foreground">{step.sharePercent}%</b> of first visits
      </p>
    </div>
  );
}
